import React from 'react';
import { FlexiflowComponent } from '@flexiflow-ui-kit/system';
import styled from 'styled-components';

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject, _templateObject2;
var HintContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", ";\n  width: 100%;\n"])), function (p) {
  return p.theme.predefinedCss.borderBoxChildren;
});
var HintText = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: 12px;\n  line-height: 14px;\n  margin: 4px 0 0;\n  min-height: 16px;\n  color: ", ";\n"])), function (p) {
  return p.disabled && p.theme.palette.gray['400'] || p.hasError && p.theme.palette.red['700'] || p.theme.palette.black;
});

function Hint(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === void 0 ? '' : _ref$className,
      children = _ref.children,
      hasError = _ref.hasError,
      hint = _ref.hint,
      hintKeepPlace = _ref.hintKeepPlace,
      disabled = _ref.disabled,
      _ref$hintCanDisabled = _ref.hintCanDisabled,
      hintCanDisabled = _ref$hintCanDisabled === void 0 ? true : _ref$hintCanDisabled;
  return /*#__PURE__*/React.createElement(FlexiflowComponent, null, /*#__PURE__*/React.createElement(HintContainer, {
    className: className
  }, !hint && !hintKeepPlace ? children : /*#__PURE__*/React.createElement(React.Fragment, null, children, /*#__PURE__*/React.createElement(HintText, {
    hasError: hasError,
    disabled: hintCanDisabled ? disabled : false
  }, hint))));
}

export { Hint };
